import type { HelpFile } from '../../types/help'
import { SpanWaterfallTestIds } from '../../../testids/SpanWaterfallTestIds'

export const spanWaterfallHelp: HelpFile = {
  docPage: '/docs/observability/traces',
  texts: {
    [SpanWaterfallTestIds.spanWaterfall]: 'Waterfall view of all spans in a trace, showing how a request was handled across services and components.',
    [SpanWaterfallTestIds.colDuration]: 'Time the span took to complete.',
    [SpanWaterfallTestIds.colSpan]: 'Span name and operation, indented to reflect the parent-child relationship.',
    [SpanWaterfallTestIds.colStatus]: 'Outcome of the span (ok, error, cancelled).',
    [SpanWaterfallTestIds.filterAll]: null,
    [SpanWaterfallTestIds.sortDuration]: null,
    [SpanWaterfallTestIds.sortTime]: null,
  },
}
